import React, { createContext, useContext, useEffect, useState } from "react";
import ChatBox from "./chatBox"; // Adjust this import path to match your file structure

// Create isolated theme context for iframe
const IframeThemeContext = createContext();

const useIframeTheme = () => {
  const context = useContext(IframeThemeContext);
  if (!context) {
    throw new Error("useIframeTheme must be used within IframeThemeProvider");
  }
  return context;
};

const IframeThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    // Get initial theme from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get("theme");
    if (themeParam) {
      setTheme(themeParam);
      document.documentElement.setAttribute("data-theme", themeParam);
      document.body.className =
        themeParam === "dark"
          ? "bg-[#0f1115] text-white min-h-screen"
          : "bg-white text-black min-h-screen";
    }

    // Listen for theme changes from parent window
    const handleMessage = (event) => {
      if (event.data?.type === "THEME_CHANGE") {
        const newTheme = event.data.theme;
        setTheme(newTheme);
        document.documentElement.setAttribute("data-theme", newTheme);
        document.body.className =
          newTheme === "dark"
            ? "bg-[#0f1115] text-white min-h-screen"
            : "bg-white text-black min-h-screen";
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <IframeThemeContext.Provider value={{ theme, toggleTheme: () => {} }}>
      {children}
    </IframeThemeContext.Provider>
  );
};

// Main component for the iframe route
const InstantChat = () => {
  const [assignments, setAssignments] = useState([]); // FIX: provide state and setter

  return (
    <IframeThemeProvider>
      <div className="w-full h-screen overflow-hidden">
        <ChatBox
          instant={true}
          assignments={assignments}
          setAssignments={setAssignments}
        />
      </div>
    </IframeThemeProvider>
  );
};

export default InstantChat;
